import { render, staticRenderFns } from "./PeopleSlider.vue?vue&type=template&id=0e0fb89b&scoped=true&"
import script from "./PeopleSlider.vue?vue&type=script&lang=js&"
export * from "./PeopleSlider.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSlider.vue?vue&type=style&index=0&id=0e0fb89b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0fb89b",
  null
  
)

export default component.exports